export const getFirstItem = <TArray, TDefaultValue>(
  array: TArray[] | undefined,
  defaultValue: TDefaultValue,
): TArray | TDefaultValue => {
  // eslint-disable-next-line no-restricted-syntax
  return array && array.length ? array[0] : defaultValue;
};
